export const baseURL = "https://obl-api.nmfb.com.ng/api/v1";
//export const baseURL =
//"https://oblv4-cmhdg0cubqekb6fp.westeurope-01.azurewebsites.net/api/v1";
// export const baseURL =
//   "https://nmfbobltest-f5ayg2a2h9g8dmhs.westeurope-01.azurewebsites.net/api/v1";

export const imgURL = baseURL.replace("/api/v1", "");
